<template>
  <div class="channels-category">
    <button href="#"
            class="category-heading"
            :class="{open: isCategoryOpen}"
            @click.prevent="isCategoryOpen = !isCategoryOpen">
      <span class="title">{{ $props.categoryTitle }}</span>
      <span class="icon-arrow-down"></span>
    </button>
    <height-transition>
      <div v-if="isCategoryOpen">
        <slot/>
      </div>
    </height-transition>
  </div>
</template>

<script>
import HeightTransition from '../common/height-transition'

export default {
  name: 'channels-sidebar-category-expand',
  components: { HeightTransition },
  props: {
    categoryTitle: String
  },
  data () {
    return {
      isCategoryOpen: true
    }
  }
}
</script>

<style scoped lang="scss">
.channels-category {
  margin-bottom: 3.2rem;

  &:last-child {
    margin-bottom: 0;
  }

  .category-heading {
    color: $primary;
    font-size: 1.8rem;
    width: 100%;
    text-align: left;
    padding: 0.8rem 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid $grey;

    span[class^="icon-"] {
      transform: rotate(180deg);
      transition: transform 0.3s;
    }

    &.open span[class^="icon-"] {
      transform: rotate(0);
    }

    .title {
      display: block;
      flex: 1 1 auto;
    }
  }
}
</style>
